/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Slow_Lucky_Frog_QuizInputs */

const fr_slow_lucky_frog_quiz = /** @type {(inputs: Slow_Lucky_Frog_QuizInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notif log`)
};

/**

* @param {Slow_Lucky_Frog_QuizInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const slow_lucky_frog_quiz = /** @type {((inputs?: Slow_Lucky_Frog_QuizInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slow_Lucky_Frog_QuizInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_slow_lucky_frog_quiz(inputs)
});